<template>
<div style="position:relative;height:60px;background:#fff;margin-top: -10px;">
  <small style="position:absolute;top:0px;left:12px;color:#aaa">Badges</small>
  <div v-if="loading" class="item-list-holder"  style="padding-top:15px">
    <Avatar class="badge badge-loading" v-for="i in 3" :key="i"/>
  </div>
  <div v-else class="item-list-holder"  style="padding-top:15px">
    <router-link  v-for="badge in orderBadges['true']" :key="badge.id" v-if="badge.type !== 'country'"
      :to="reRoute(badge)">
      <Avatar :src="badge | getDisplayImage" :class="{ 'grayscale': !badge.subscribed  }"
        icon="trophy" class="badge" style="border:1px solid #aaa"
        />
    </router-link>
    <div v-if="dotDelimiter" style="line-height:35px;padding:0 10px;margin-right:6px;width:1px;background:#fff;width:25px;height:33px;display:inline-block;vertical-align:top">
      <Avatar style="width:5px;height:5px"></Avatar>
    </div>
    <!-- <Avatar v-if="orderBadges['true'].length > 0" class="badge grayscale" style="border:1px solid #aaa" /> -->
    <router-link  v-for="badge in orderBadges['false']" :key="badge.id"
      :to="reRoute(badge)">
      <Avatar :src="badge | getDisplayImage" :class="{ 'grayscale': !badge.subscribed  }"
        icon="trophy" class="badge" style="border:1px solid #aaa"
        />
    </router-link>
  </div>
</div>
</template>

<script>
import utils from '@/utils'
import Cons from '@/constants.json'

export default {
  props: {
    userId: {
      type: String,
      required: true
    },
    journalId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false
    }
  },
  watch: {
    journalId: function(n) {
      if (n) this.getJournal()
    }
  },
  computed: {
    dotDelimiter: function() {
      if (this.orderBadges['true'] == undefined) return false;
      else if (this.orderBadges['true'].length > 0) return true;
      else if (this.orderBadges['true'].length === 1 && this.orderBadges['true'][0].type !== 'country') return true;
      else return false;      
    },
    badges: {
      get() {
        let honoraryID = Cons[0].GROUP_ID.honoraryBadgeActivityId[process.env.VUE_APP_DEV_STATUS]
        if(this.$store.state.publicProfile.myBadges.data && this.$store.state.publicProfile.myBadges.data.length == 0){
          return [];
        }else if(!this.$store.state.publicProfile.myBadges.data){
          return [];
        }
        return this.$store.state.publicProfile.myBadges.data.filter(e => e.id !== honoraryID)
      }
    },
    orderBadges: {
      get() {
        var badges = _.groupBy(this.badges, 'subscribed')
        if(!badges['true']) badges['true'] = []
        if(!badges['false']) badges['false'] = []
        return badges
      }
    }
  },
  mounted() {
    // console.log(this.journalId)
    if(this.journalId)
      this.getJournal()
  },
  methods: {
    reRoute(badge) {
      if( badge.type === 'badge')
        return '/resources/' + badge.id + '?tab=followers&r-type=badge'
      return '/resources/' + badge.id + '?tab=posts'
    },
    getJournal() {
      this.loading = true
      this.$store.dispatch('publicProfile/getBadges', { journalId: this.journalId, userId: this.userId })
        .then( () => this.loading = false)
    }
  },
  filters: {
    getDisplayImage(data) {
      return utils.getDisplayImage('group', data, 'small')
    }
  }
};
</script>

<style scoped>
.item-list-holder {
  overflow: auto;
  white-space: nowrap;
  /* margin-top: 5px; */
  padding: 5px 10px 9px;
  margin-bottom: 0px;
  border-bottom: 1px solid #ddd;
}

.badge {
  border-radius:100%;
  margin-right:6px;
  width:35px;
  height:35px;
  cursor: pointer;
}

.badge-loading {
  cursor: unset;
  background: linear-gradient(-45deg, #dadada, #c0c0c0, #ffffff);
  background-size: 400% 400%;
	-webkit-animation: Gradient 3s ease infinite;
	-moz-animation: Gradient 3s ease infinite;
	animation: Gradient 3s ease infinite;
}

@-moz-keyframes Gradient {
	0% {
		background-position: 0% 50%
	}
	50% {
		background-position: 100% 50%
	}
	100% {
		background-position: 0% 50%
	}
}

@keyframes Gradient {
	0% {
		background-position: 0% 50%
	}
	50% {
		background-position: 100% 50%
	}
	100% {
		background-position: 0% 50%
	}
}
</style>
